<template>
  <div>
    <router-view />
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'Index',
};
</script>